function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 504.8 504.8",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00A6F9"
    },
    d: "M480,203.5c-6.4,0-12-2.4-16.8-7.2c-116.8-116-305.6-116-422.4,0c-9.6,9.6-24.8,9.6-33.6,0 c-9.6-9.6-9.6-24.8,0-33.6c135.2-135.2,355.2-135.2,490.4,0c9.6,9.6,9.6,24.8,0,33.6C492.8,201.1,486.4,203.5,480,203.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00A6F9"
    },
    d: "M396,288.3c-6.4,0-12-2.4-16.8-7.2c-70.4-70.4-184-70.4-254.4,0c-9.6,9.6-24.8,9.6-33.6,0 c-9.6-9.6-9.6-24.8,0-33.6c88.8-88.8,232.8-88.8,321.6,0c9.6,9.6,9.6,24.8,0,33.6C408,285.9,402.4,288.3,396,288.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00A6F9"
    },
    d: "M309.6,369.1c-6.4,0-12-2.4-16.8-7.2c-22.4-22.4-59.2-22.4-81.6,0c-9.6,9.6-24.8,9.6-33.6,0 c-9.6-9.6-9.6-24.8,0-33.6c40.8-40.8,108-40.8,148.8,0c9.6,9.6,9.6,24.8,0,33.6C321.6,366.7,316,369.1,309.6,369.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#00A6F9"
    },
    cx: 252,
    cy: 419.5,
    r: 24
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0093F7"
    },
    d: "M7.2,189.1c-0.8,0.8-2.4,2.4-3.2,4c0.8,1.6,1.6,2.4,3.2,4c9.6,9.6,24.8,9.6,33.6,0 c116.8-116.8,305.6-116.8,422.4,0c4.8,4.8,11.2,7.2,16.8,7.2s12-2.4,16.8-7.2c0.8-0.8,2.4-2.4,3.2-4c-0.8-1.6-1.6-2.4-3.2-4 C361.6,53.9,142.4,53.9,7.2,189.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0093F7"
    },
    d: "M91.2,273.9c-0.8,0.8-2.4,2.4-3.2,4c0.8,1.6,1.6,2.4,3.2,4c9.6,9.6,24.8,9.6,33.6,0 c70.4-70.4,184-70.4,254.4,0c4.8,4.8,11.2,7.2,16.8,7.2s12-2.4,16.8-7.2c0.8-0.8,2.4-2.4,3.2-4c-0.8-1.6-1.6-2.4-3.2-4 C324,185.1,180,185.1,91.2,273.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0093F7"
    },
    d: "M177.6,354.7c-0.8,0.8-2.4,2.4-3.2,4c0.8,1.6,1.6,2.4,3.2,4c9.6,9.6,24.8,9.6,33.6,0 c22.4-22.4,59.2-22.4,81.6,0c4.8,4.8,11.2,7.2,16.8,7.2s12-2.4,16.8-7.2c0.8-0.8,2.4-2.4,3.2-4c-0.8-1.6-1.6-2.4-3.2-4 C285.6,313.1,218.4,313.1,177.6,354.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0093F7"
    },
    d: "M252,421.9c-8,0-16,4-20,10.4c4,6.4,12,10.4,20,10.4s16-4,20-10.4C268,426.7,260,421.9,252,421.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.dfd9f83e6988e2943967f95948d6d8c0.svg";
export { ForwardRef as ReactComponent };